import { useEffect, useRef } from 'react';
import type { GameController } from '../core/GameController';
import { GameRenderer } from '../render/GameRenderer';

interface GameCanvasProps {
  controller: GameController;
}

export function GameCanvas({ controller }: GameCanvasProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;
    const renderer = new GameRenderer(controller);
    renderer.mount(containerRef.current);
    return () => renderer.dispose();
  }, [controller]);

  return <div ref={containerRef} className="game-viewport" data-testid="game-viewport" />;
}
